import { render } from "./ModalElevatorTurnOffAlarm.vue?vue&type=template&id=1bc2cb10&scoped=true"
import script from "./ModalElevatorTurnOffAlarm.vue?vue&type=script&lang=js"
export * from "./ModalElevatorTurnOffAlarm.vue?vue&type=script&lang=js"

import "./ModalElevatorTurnOffAlarm.vue?vue&type=style&index=0&id=1bc2cb10&lang=scss&scoped=true"

import exportComponent from "/Users/dmytrokulyk/Documents/Development/GreenHub/dsp-f-2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bc2cb10"]])

export default __exports__